import { configureStore } from '@reduxjs/toolkit'
import markerplaceReducer from './components/marketplace/marketplaceReducer'
import walletConnectReducer from './components/ConnectWallet/walletConnectReducer'
import { Headerreducer } from './components/Banner/headerreducer'
export const store = configureStore({
  reducer: {
    marketplace: markerplaceReducer,
    walletConnect: walletConnectReducer,
    headerreducer: Headerreducer
  }
})
